import { apiConfig } from '../../config';

export function setActiveBeam(commissioningId, azEl) {
  const auth = window.__APP_AUTH;
  let url = apiConfig.commissionServiceSetActiveBeam(commissioningId);
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  let body = {
    activeBeam: azEl
  };

  return fetch(url, { headers: headers, method: 'POST', body: JSON.stringify(body) }).then((response) => {
    if (response.status === 200) {
      return response.json().then((res) => {
        console.log(res);
        return res;
      });
    } else {
      return response.text().then((error) => {
        console.log('Error in set active beam:', error);
        alert('Failed to set active beam:', error);
        throw new Error(error);
      });
    }
  });
}

export function setServicesActiveBeam(commissioningId, data) {
  const auth = window.__APP_AUTH;
  const url = apiConfig.commissionServiceSetServicesActiveBeam(commissioningId);
  const headers = {
    Accept: '*application/json*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'Content-Type': 'application/json'
  };

  const body = data;

  return fetch(url, { headers: headers, method: 'POST', body: JSON.stringify(body) }).then((response) => {
    if (response.status === 200) {
      return response.json().then((res) => {
        console.log(res);
        return res;
      });
    } else {
      return response.text().then((error) => {
        console.log('Error in set active beam:', error);
        alert('Failed to set active beam:', error);
        throw new Error(error);
      });
    }
  });
}
